<template>
  <span
    ref="triggerRef"
    @mouseenter="show"
    @mouseleave="hide"
    @focus="show"
    @blur="hide"
  >
    <slot />
  </span>
  <Teleport to="body">
    <div
      v-if="visible"
      ref="tooltipRef"
      role="tooltip"
      class="pointer-events-none fixed z-9999 w-max max-w-[240px] rounded-md bg-gray-900 px-3 py-2 text-left text-xs leading-relaxed text-white shadow-lg"
      :style="tooltipStyle"
    >
      <slot name="content" />
    </div>
  </Teleport>
</template>

<script setup>
import { nextTick, ref } from 'vue';

const triggerRef = ref(null);
const tooltipRef = ref(null);
const visible = ref(false);
const tooltipStyle = ref({ top: '0px', left: '0px', transform: 'translateX(-50%)' });

const positionTooltip = () => {
  const trigger = triggerRef.value;
  const tooltip = tooltipRef.value;
  if (!trigger || !tooltip) return;

  const rect = trigger.getBoundingClientRect();
  const gap = 8;
  const tooltipHeight = tooltip.offsetHeight;
  const viewportPadding = 8;

  let top = rect.bottom + gap;
  if (top + tooltipHeight > window.innerHeight - viewportPadding) {
    top = rect.top - tooltipHeight - gap;
  }

  tooltipStyle.value = {
    top: `${Math.max(viewportPadding, top)}px`,
    left: `${rect.left + rect.width / 2}px`,
    transform: 'translateX(-50%)',
  };
};

const show = async () => {
  visible.value = true;
  await nextTick();
  positionTooltip();
};

const hide = () => {
  visible.value = false;
};
</script>
